
import {useState} from "react";
import {IconButton, Menu, MenuItem} from "@material-ui/core";
import MenuIcon from "@mui/icons-material/Menu";
import {Link, Typography} from "@mui/material";

function MobileMenu() {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton
                onClick={handleClick}
                size="large"
                edge="start"
                aria-label="menu"
                sx={{ mr: 2, color: "black" }}
            >
                <MenuIcon />
            </IconButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}
            >
                <MenuItem component={Link} href="https://gto.moscow.sport/#rec358963142">
                    <Typography sx={{
                        fontSize: "20px",
                        color: "#eb3333",
                        marginRight: "30px",
                        letterSpacing: "1px",
                        fontFamily: "Mossport",
                    }}>
                        О ПРОЕКТЕ
                    </Typography>
                </MenuItem>

                <MenuItem component={Link} href="https://gto.moscow.sport/#rec359015806">
                    <Typography sx={{
                        fontSize: "20px",
                        color: "#eb3333",
                        marginRight: "30px",
                        letterSpacing: "1px",
                        fontFamily: "Mossport",
                    }}>
                        ПРИЗЫ
                    </Typography>
                </MenuItem>

                <MenuItem component={Link} href="https://gto.moscow.sport/#rec358972049">
                    <Typography sx={{
                        fontSize: "20px",
                        color: "#eb3333",
                        marginRight: "30px",
                        letterSpacing: "1px",
                        fontFamily: "Mossport",
                    }}>
                        РАСПИСАНИЕ
                    </Typography>
                </MenuItem>

                <MenuItem component={Link}   href="https://gto.moscow.sport/#rec359297804">
                    <Typography sx={{
                        fontSize: "20px",
                        color: "#eb3333",
                        marginRight: "30px",
                        letterSpacing: "1px",
                        fontFamily: "Mossport",
                    }}>
                        АКТИВНОСТИ
                    </Typography>
                </MenuItem>

                <MenuItem component={Link} href="https://gto.moscow.sport/#rec358978095">
                    <Typography sx={{
                        fontSize: "20px",
                        color: "#eb3333",
                        marginRight: "30px",
                        letterSpacing: "1px",
                        fontFamily: "Mossport",
                    }}>
                        КАК НАС НАЙТИ
                    </Typography>
                </MenuItem>

                <MenuItem component={Link} href="https://gto-moscow-sport.web.app/">
                    <Typography sx={{
                        fontSize: "20px",
                        color: "#eb3333",
                        marginRight: "30px",
                        letterSpacing: "1px",
                        fontFamily: "Mossport",
                    }}>
                        ЛИЧНЫЙ КАБИНЕТ
                    </Typography>
                </MenuItem>
            </Menu>
        </>
    );
}

export default MobileMenu;